module.exports = __webpack_public_path__ + "img/icons_40.11efa5d7.png";